






































































import { Component, Vue, Mixins, Prop } from "vue-property-decorator";
import { ClassColumnDataTable } from "@/components/DataTableGenerico/ClassColumnDataTable";
import { datatypes } from "@/components/DataTableGenerico/datatypes";
import BaseListaClass from "@/shared/classes/BaseListaClass";
import { producto } from "@/shared/dtos/producto";
import { RouterNames } from "@/router/routernames";
import { ClassTypeSelectionRow } from "@/components/DataTableGenerico/ClassTypeSelectionRow";
import { MessageService } from "@/shared/services/message-service";
import pantalla_modo_listaModule from "@/store/modules/pantalla_modo_lista-module";
import { pantalla_modo_lista } from "@/shared/dtos/dynamic_tables/pantalla_modo_lista";
import { ssmHttpService } from "@/shared/services/http-service";
import { API } from "@/shared/api";
import { DxColumn, DxButton } from "devextreme-vue/data-grid";
import productoModule from "@/store/modules/producto-module";
import ocultarcamposModule from "@/store/modules/ocultarcampos-module";
import { UtilsString } from "@/utils/utils-string";
import { ProcessoNums, getTexto } from "../procesos/ProcessoNums";

@Component({
  components: { DxColumn, DxButton },
})
export default class DxTableHistorialVenta extends Mixins(BaseListaClass) {
  public FormKey: number = 0;
  public FormId: number = -1;
  public proceso_venta_show: boolean = false;
  public pantalla_modo_lista: pantalla_modo_lista = new pantalla_modo_lista();
  public datasource: any[] = [];
  @Prop({ default: 0 }) id_tabla!: number;
  public popupVisible: boolean = false;
  public selectedRow: producto = new producto();
  public get DataSource() {
    /*
    subcategory
    category
    */

    try {
      ssmHttpService
        .get(API.webApiBase + this.pantalla_modo_lista.pantalla.api_call)
        .then((res) => {
          var productos = res ? res.map((x: producto) => new producto(x)) : [];
          if (productos.length > 0) {
            if (ocultarcamposModule.Ocultar_tarjeta_efectivo) {
              productos = productos.filter(
                (x: producto) => x.estado === ProcessoNums.VendidoTarjeta
              );
            }
          }

          this.datasource = productos;
        });
    } catch (error) {}

    this.datasource = [];

    return "";
  }

  calculatePrecioVenta(rowData: any) {
    // Calcula el 50% del valor de la columna total_retail
    return (
      Math.round(
        (rowData.total_retail ? rowData.total_retail * 0.5 : 0) * 100
      ) /
        100 +
      " €"
    );
  }

  estadoTemplate(rowData: any) {
    return getTexto(rowData.estado);
  }

  amazonLinkTemplate(container: any, options: any) {
    if (options.value) {
      const link = document.createElement("a");
      link.href = options.value; // Valor del campo link_amazon
      link.textContent = "Amazon"; // Texto visible
      link.target = "_blank"; // Abre en una nueva pestaña
      link.rel = "noopener noreferrer"; // Seguridad adicional
      link.style.color = "black"; // Define el color negro para el texto del enlace
      link.style.textDecoration = "none"; // Opcional: elimina el subrayado
      container.appendChild(link);
    } else {
      container.textContent = "No disponible"; // Texto por defecto si el enlace está vacío
    }
  }

  public RowRemoved(e: any) {}

  public Salir() {
    //@ts-ignore
    this.DataTable.VisualDxDataGrid.instance.cancelEditData();
  }

  public EmpiezoEditar(e: any) {
    this.FormId = parseInt(this.DataTable.RowIndex());
    this.FormKey += 1;
    // let index = this.DataTable.RowIndex();
    // this.$router.push({
    //   name: RouterNames.paisesformulario,
    //   query: { Id: index }
    // });
  }
  public EmpiezoCrear(e: any) {
    this.FormId = -1;
    this.FormKey += 1;
    this.$router.push({
      name: RouterNames.stockcrear_nuevo,
      params: { id: "-1" },
    });
  }

  abrir_producto(e: any) {
    var rowSelected = e.row.key;
    e.event.preventDefault();
    this.selectedRow = new producto(e.row.data);
    this.$router.push({
      name: RouterNames.fichaproducto,
      params: { id: this.selectedRow.id },
    });
  }

  public get Columns() {
    let Columnas: ClassColumnDataTable[] = [];
    if (this.pantalla_modo_lista.columnas === undefined) {
      return Columnas;
    }

    for (let i = 0; i < this.pantalla_modo_lista.columnas.length; i++) {
      let item = this.pantalla_modo_lista.columnas[i];
      var datatype = datatypes.string;

      switch (item.tipo_de_dato.nombre) {
        case "string":
          var datatype = datatypes.string;
          break;
        case "boolean":
          var datatype = datatypes.boolean;
          break;
        case "numeric":
          var datatype = datatypes.number;
          break;
        case "Date":
          var datatype = datatypes.date;
          break;
        case "DateTime":
          var datatype = datatypes.datetime;
          break;
        default:
          var datatype = datatypes.string;
          break;
      }
      if (
        !ocultarcamposModule.mostrar_campos_coste &&
        item.nombre.toLocaleLowerCase() === "coste"
      ) {
      } else {
        Columnas.push(
          new ClassColumnDataTable(
            item.data_bilding,
            item.nombre,
            datatype,
            item.visible,
            datatypes.maxlength
          )
        );
      }
    }
    return Columnas;
  }
  get get_id_tabla() {
    let id = this.$route.meta.id;
    if (id === undefined) {
      id = this.$route.params.id;
    }
    if (this.id_tabla > 0) {
      id = this.id_tabla;
    }
    return id;
  }
  public async Refresh() {
    pantalla_modo_listaModule
      .getpantalla_modo_lista(this.get_id_tabla)
      .then((x: pantalla_modo_lista) => {
        this.pantalla_modo_lista = x;
      });
  }
  get mostrarCamposCoste() {
    return ocultarcamposModule.mostrar_campos_coste;
  }
}
